module.exports = "/_next/static/images/quality-illustration-6a2aa50e001b761c3e06b337b57bfe22.svg";